import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await register(form);
    setSubmitting(false);
    if (res.ok) {
      toast.success(`Account created. Welcome ${res.user.name}!`);
      navigate("/dashboard");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-[calc(100vh-72px)] grid lg:grid-cols-2" data-testid="register-page">
      <div className="flex items-center justify-center p-8 order-2 lg:order-1">
        <form onSubmit={handleSubmit} data-testid="register-form" className="w-full max-w-md">
          <div className="overline mb-4">Join OC Infraventures</div>
          <h1 className="font-serif text-4xl text-slate-900 font-light mb-2">Create your account</h1>
          <p className="text-xs text-slate-500 mb-10">Password must be 8+ characters with at least one uppercase letter and one digit.</p>

          {error && (
            <div className="mb-6 p-3 border border-red-500/30 bg-red-950/30 text-red-300 text-sm" data-testid="register-error">{error}</div>
          )}

          {[
            { label: "Full Name", key: "name", type: "text", testId: "reg-name" },
            { label: "Email", key: "email", type: "email", testId: "reg-email" },
            { label: "Phone", key: "phone", type: "tel", testId: "reg-phone" },
            { label: "Password", key: "password", type: "password", testId: "reg-password" },
          ].map((f) => (
            <div key={f.key} className="mb-5">
              <label className="overline block mb-2">{f.label}</label>
              <input
                required={f.key !== "phone"}
                type={f.type}
                value={form[f.key]}
                onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                data-testid={f.testId}
                className="w-full bg-slate-50 border border-slate-100 px-4 py-3 focus:outline-none focus:border-amber-500"
              />
            </div>
          ))}

          <button type="submit" disabled={submitting} data-testid="register-submit"
            className="mt-3 w-full bg-[#D4A437] text-white py-3 font-medium hover:bg-[#D4A437] transition-colors disabled:opacity-60">
            {submitting ? "Creating account..." : "Create Account →"}
          </button>
          <div className="mt-6 text-sm text-slate-600 text-center">
            Already a member? <Link to="/login" className="text-[#D4A437] hover:underline" data-testid="link-to-login">Sign in</Link>
          </div>
        </form>
      </div>

      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tl from-slate-950 via-slate-950/60 to-transparent" />
        <div className="absolute bottom-12 right-12 left-12 text-right">
          <div className="overline mb-3">List · Compare · Track</div>
          <h2 className="font-serif text-4xl text-slate-900 leading-tight">Reach 12,000+ verified buyers across the world.</h2>
        </div>
      </div>
    </div>
  );
}
